<template>
  <div class="custom-content" ref="wrapper">
    <div class="btn-to-top" @click="$refs.wrapper.scrollTo(0, 0)">
      <svg width="16" height="9" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.33754 8.77624L8 2.01381L14.6625 8.77624C14.9653 9.07458 15.47 9.07458 15.7729 8.77624C16.0757 8.4779 16.0757 7.98066 15.7729 7.58287L8.60568 0.223757C8.30284 -0.074586 7.79811 -0.074586 7.49527 0.223757L0.227128 7.48342C-0.0757106 7.78177 -0.0757107 8.279 0.227128 8.67679C0.529967 9.07458 1.0347 9.07458 1.33754 8.77624Z" fill="#F68C1E"/>
      </svg>
    </div>

    <go-back @click="$emit('close')" :text="getGoBackText"/>
    <k-spinner v-if="recipeLoading" class="mx-auto" />
    <div v-else-if="lockedRecipe" class="row" style="padding-bottom: 75px">
      <div class="col-lg-12 col-xl-8 mb-2">
        <div class="k-recipe__card k-recipe__about col-12 p-0">
          <div class="d-flex" style="min-height: 100%;">
            <div class="k-image__overblock col-xs-12 col-lg-5 col-xl-5 p-0 d-flex align-items-center flex-column">
              <img v-if="lockedRecipe.cover_url" class="k-recipe__image k-recipe__about-image" :src="lockedRecipe.cover_url" :alt="lockedRecipe.title">
            </div>
            <div class="k-recipe__about-text col-xs-12 col-lg-7 col-xl-7">
              <h2>{{ lockedRecipe.title }}
                <svg class="k-menu__lock ml-2" width="17" height="24" viewBox="0 0 17 24" role="img" aria-label="Рецепт закрыт">
                  <path d="M14.1312 9.49941V5.80519C14.1312 2.63873 11.5812 0 8.4999 0C5.41865 0 2.86865 2.63873 2.86865 5.80519V9.49941H5.7374V5.80519C5.63115 4.22196 6.90615 2.84982 8.4999 2.84982C10.0937 2.84982 11.3687 4.11641 11.3687 5.80519V9.49941H14.1312Z" fill="#C1C1C1"/>
                  <path d="M0 13.0883V20.3711C0 21.9544 1.275 23.221 2.86875 23.221H14.2375C15.8312 23.221 17.1063 21.9544 17.1063 20.2656V12.9827C17.1063 11.3995 15.8312 10.0273 14.2375 10.0273H2.86875C1.275 10.1329 0 11.505 0 13.0883Z" fill="#C1C1C1"/>
                </svg>
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="readError" role="alert" class="recovery-notice">
      {{ readError }}
      <button v-if="readErrorRetryable" type="button" @click="loadRecipe">Повторить загрузку</button>
    </div>
    <div class="row" style="padding-bottom: 75px" v-if="recipe && !readError && !recipeLoading">
      <div class="col-12 p-0 p-md-3" v-if="recipe.preparing_desc">
        <div class="k-recipe__warning col-12 d-flex mb-3 mb-md-0">
          <div class="k-recipe__warning-text">
            <h2>Требуется подготовка!</h2>
            <p>{{ recipe.preparing_desc }}</p>
          </div>
        </div>
      </div>
      <div class="k-recipe__row d-flex flex-wrap mb-2 w-100">
        <!-- Главная карточка -->
        <div class="col-lg-12 col-xl-8 mb-2 mb-xl-0">
          <div class="k-recipe__card k-recipe__about col-12 p-0">
            <div class="d-flex" style="min-height: 100%;">
              <div class="k-image__overblock col-xs-12 col-lg-5 col-xl-5 p-0 d-flex align-items-center flex-column">
                <img class="k-recipe__image k-recipe__about-image" :src="recipe.cover_url" alt="Recipe image">
                <div v-if="isNotFullProfile" style="position: relative; z-index: 10">
                  <span v-if="$mq === 'xs' || $mq === 'sm'" class="k-recipe__tip-absolute">
                    <svg @click="profile_tip = true" v-if="!profile_tip" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8 0C3.57841 0 0 3.578 0 8C0 12.4215 3.578 16 8 16C12.4216 16 16 12.422 16 8C16 3.57841 12.422 0 8 0ZM8 14.8837C4.20431 14.8837 1.11628 11.7957 1.11628 8C1.11628 4.20428 4.20431 1.11628 8 1.11628C11.7957 1.11628 14.8837 4.20428 14.8837 8C14.8837 11.7957 11.7957 14.8837 8 14.8837Z" fill="#808080"/>
                      <path d="M7.76345 10.126C7.32117 10.126 6.96313 10.4945 6.96313 10.9368C6.96313 11.3686 7.31063 11.7477 7.76345 11.7477C8.21626 11.7477 8.57426 11.3686 8.57426 10.9368C8.57426 10.4945 8.2057 10.126 7.76345 10.126Z" fill="#808080"/>
                      <path d="M7.90018 3.9834C6.47856 3.9834 5.82568 4.82587 5.82568 5.39449C5.82568 5.80518 6.17318 5.99474 6.4575 5.99474C7.02615 5.99474 6.7945 5.18387 7.86859 5.18387C8.39509 5.18387 8.81634 5.41555 8.81634 5.89996C8.81634 6.46859 8.22662 6.79502 7.87912 7.08987C7.57371 7.35309 7.17359 7.78487 7.17359 8.69049C7.17359 9.23806 7.32103 9.39602 7.75275 9.39602C8.26871 9.39602 8.37403 9.16437 8.37403 8.96424C8.37403 8.41668 8.38456 8.10077 8.96375 7.64796C9.24806 7.42684 10.1431 6.71074 10.1431 5.7209C10.1431 4.73105 9.24806 3.9834 7.90018 3.9834Z" fill="#808080"/>
                    </svg>
                    <svg @click="profile_tip = false" v-else width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="8" cy="8" r="8" fill="#F68C1E"/>
                      <path d="M7.7632 10.1406C7.32092 10.1406 6.96289 10.5092 6.96289 10.9514C6.96289 11.3832 7.31039 11.7623 7.7632 11.7623C8.21602 11.7623 8.57402 11.3832 8.57402 10.9514C8.57402 10.5092 8.20545 10.1406 7.7632 10.1406Z" fill="white"/>
                      <path d="M7.89969 4C6.47807 4 5.8252 4.84247 5.8252 5.41109C5.8252 5.82178 6.1727 6.01134 6.45701 6.01134C7.02566 6.01134 6.79401 5.20047 7.8681 5.20047C8.3946 5.20047 8.81585 5.43216 8.81585 5.91656C8.81585 6.48519 8.22613 6.81163 7.87863 7.10647C7.57323 7.36969 7.1731 7.80147 7.1731 8.70709C7.1731 9.25466 7.32054 9.41263 7.75226 9.41263C8.26823 9.41263 8.37354 9.18097 8.37354 8.98084C8.37354 8.43328 8.38407 8.11737 8.96326 7.66456C9.24757 7.44344 10.1426 6.72734 10.1426 5.7375C10.1426 4.74766 9.24757 4 7.89969 4Z" fill="white"/>
                    </svg>
                  </span>
                  <div class="k-recipe__tooltip" :class="{ active: profile_tip }">
                    <div class="m-3 d-flex">
                      <div class="mr-2">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M8 0C3.57841 0 0 3.578 0 8C0 12.4215 3.578 16 8 16C12.4216 16 16 12.422 16 8C16 3.57841 12.422 0 8 0ZM8 14.8837C4.20431 14.8837 1.11628 11.7957 1.11628 8C1.11628 4.20428 4.20431 1.11628 8 1.11628C11.7957 1.11628 14.8837 4.20428 14.8837 8C14.8837 11.7957 11.7957 14.8837 8 14.8837Z" fill="white"/>
                          <path d="M7.76369 10.1262C7.32141 10.1262 6.96338 10.4948 6.96338 10.937C6.96338 11.3688 7.31088 11.7479 7.76369 11.7479C8.2165 11.7479 8.5745 11.3688 8.5745 10.937C8.5745 10.4948 8.20594 10.1262 7.76369 10.1262Z" fill="white"/>
                          <path d="M7.90018 3.9834C6.47856 3.9834 5.82568 4.82587 5.82568 5.39449C5.82568 5.80518 6.17318 5.99474 6.4575 5.99474C7.02615 5.99474 6.7945 5.18387 7.86859 5.18387C8.39509 5.18387 8.81634 5.41555 8.81634 5.89996C8.81634 6.46859 8.22662 6.79502 7.87912 7.08987C7.57371 7.35309 7.17359 7.78487 7.17359 8.69049C7.17359 9.23806 7.32103 9.39602 7.75275 9.39602C8.26871 9.39602 8.37403 9.16437 8.37403 8.96424C8.37403 8.41668 8.38456 8.10077 8.96375 7.64796C9.24806 7.42684 10.1431 6.71074 10.1431 5.7209C10.1431 4.73105 9.24806 3.9834 7.90018 3.9834Z" fill="white"/>
                        </svg>
                      </div>
                      <div>
                        Завершите расчёт калорийности в настройках профиля, чтобы увидеть % от дневной нормы
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="k-recipe__about-text col-xs-12 col-lg-7 col-xl-7">
                <div>
                  <h2>{{ recipe.title }}</h2>
                  <p v-html="parseLinks(recipe.recipe_proportion.description).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                </div>
                <div class="k-recipe__button jq-eat-show-popup col-xl-6" v-if="false">Добавить в дневник</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Характеристики -->
        <div class="col-xl-4">
          <div class="k-recipe__card k-recipe__card--default col-12 p-0 p-md-3">
            <div class="k-recipe__card-title">Характеристики</div>
            <div class="d-flex flex-wrap align-items-start">
              <div class="d-flex justify-content-between align-items-start col-xl-12 col-lg-6 px-0 px-md-4 p-xl-0 mb-3">
                <div class="k-recipe__composit">
                  <div class="k-recipe__composit-row">
                    <span>Ккал</span>
                    <div class="k-recipe__composit-progress">
                      <span class="k-recipe__composit-progress-line" style="width: 77%"></span>
                    </div>
                    <span>{{ recipe.info.calories }}</span>
                    <span>{{ recipe.info.caloriesPercent }}%</span>
                  </div>
                  <div class="k-recipe__composit-row">
                    <span>Б</span>
                    <div class="k-recipe__composit-progress">
                      <span class="k-recipe__composit-progress-line" :style="{ width: `${recipe.info.proteinsPercent}%` }"></span>
                    </div>
                    <span>{{ Math.round(recipe.info.proteinsWeight * 100 / recipe.mass_change) }} г</span>
                    <span>{{ recipe.info.proteinsPercent }}%</span>
                  </div>
                  <div class="k-recipe__composit-row">
                    <span>Ж</span>
                    <div class="k-recipe__composit-progress">
                      <span class="k-recipe__composit-progress-line" :style="{ width: `${recipe.info.fatsPercent}%` }"></span>
                    </div>
                    <span>{{ Math.round(recipe.info.fatsWeight * 100 / recipe.mass_change) }} г</span>
                    <span>{{ recipe.info.fatsPercent }}%</span>
                  </div>
                  <div class="k-recipe__composit-row">
                    <span>У</span>
                    <div class="k-recipe__composit-progress">
                      <span class="k-recipe__composit-progress-line" :style="{ width: `${recipe.info.carbohydratesPercent}%` }"></span>
                    </div>
                    <span>{{ Math.round(recipe.info.carbohydratesWeight * 100 / recipe.mass_change) }} г</span>
                    <span>{{ recipe.info.carbohydratesPercent }}%</span>
                  </div>
                </div>
                <div class="d-flex flex-column align-items-center justify-content-center">
                  <p class="k-recipe__short-desc m-0">
                    <span class="mr-2 d-flex" style="min-width: 25px">
                     <svg width="18" height="18" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 0C2.6916 0 0 2.6916 0 6C0 9.3084 2.6916 12 6 12C9.3084 12 12 9.3084 12 6C12 2.6916 9.3084 0 6 0ZM6 10.7233C3.3956 10.7233 1.27657 8.60453 1.27657 6C1.27657 3.39547 3.3956 1.2767 6 1.2767C8.60441 1.2767 10.7234 3.39547 10.7234 6C10.7234 8.60453 8.60441 10.7233 6 10.7233Z" fill="#666666" fill-opacity="0.6"/>
                        <path d="M9.12698 5.81472H6.43057V2.57264C6.43057 2.29982 6.20936 2.07861 5.93654 2.07861C5.66371 2.07861 5.4425 2.29982 5.4425 2.57264V6.30875C5.4425 6.58158 5.66371 6.80278 5.93654 6.80278H9.12698C9.39981 6.80278 9.62101 6.58158 9.62101 6.30875C9.62101 6.03592 9.39981 5.81472 9.12698 5.81472Z" fill="#666666" fill-opacity="0.6"/>
                      </svg>

                    </span>
                    {{ recipe.cooking_time + recipe.preparing_time }} минут
                  </p>
                  <p class="k-recipe__short-desc m-0">
                    <span class="mr-2 d-flex" style="min-width: 25px">
                      <svg width="23" height="22" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.92763 11.9995C4.58759 11.9995 3.30243 11.4672 2.35488 10.5197C1.40733 9.57211 0.875 8.28695 0.875 6.94691C0.875 5.60687 1.40733 4.32172 2.35488 3.37417C3.30243 2.42662 4.58759 1.89429 5.92763 1.89429C6.09513 1.89429 6.25578 1.96083 6.37422 2.07927C6.49266 2.19772 6.5592 2.35836 6.5592 2.52587V6.31534H10.3487C10.5162 6.31534 10.6768 6.38188 10.7953 6.50032C10.9137 6.61876 10.9803 6.77941 10.9803 6.94691C10.9787 8.28649 10.4459 9.57077 9.49871 10.518C8.55149 11.4652 7.2672 11.998 5.92763 11.9995ZM5.29605 3.20986C4.61033 3.3259 3.96977 3.62841 3.44453 4.08425C2.91928 4.54009 2.52961 5.13169 2.3182 5.79424C2.10678 6.45679 2.08177 7.16475 2.24591 7.84057C2.41004 8.51639 2.757 9.13401 3.24877 9.62577C3.74053 10.1175 4.35815 10.4645 5.03397 10.6286C5.70979 10.7928 6.41775 10.7678 7.0803 10.5563C7.74285 10.3449 8.33445 9.95526 8.79029 9.43001C9.24613 8.90477 9.54864 8.26421 9.66467 7.57849H5.92763C5.76012 7.57849 5.59948 7.51195 5.48103 7.39351C5.36259 7.27506 5.29605 7.11442 5.29605 6.94691V3.20986Z" fill="#666666" fill-opacity="0.6"/>
                        <path d="M12.2434 5.68421H7.82237C7.65487 5.68421 7.49422 5.61766 7.37578 5.49922C7.25734 5.38078 7.1908 5.22013 7.1908 5.05263V0.631578C7.1908 0.464073 7.25734 0.303429 7.37578 0.184985C7.49422 0.0665411 7.65487 0 7.82237 0C9.16195 0.00150449 10.4462 0.534316 11.3935 1.48154C12.3407 2.42877 12.8735 3.71305 12.875 5.05263C12.875 5.22013 12.8085 5.38078 12.69 5.49922C12.5716 5.61766 12.4109 5.68421 12.2434 5.68421ZM8.45395 4.42105H11.5594C11.4269 3.64566 11.057 2.93052 10.5007 2.37429C9.94448 1.81805 9.22934 1.44814 8.45395 1.31558V4.42105Z" fill="#666666" fill-opacity="0.6"/>
                      </svg>

                    </span>
                    {{ recipe.info.weight }} г
                  </p>
                </div>
              </div>
              <div class="col-xl-12 col-lg-6 px-0 px-md-4 p-xl-0">
                <div class="d-flex" v-if="recipe.inventories && recipe.inventories.length > 0">
                  <p class="m-0 mr-2">Инвентарь</p>
                  <div class="px-2 d-flex flex-wrap align-items-center justify-content-end w-100">
                    <span
                      class="k-badge badge k-badge-gray mx-1 my-1 d-flex flex-nowrap align-items-center"
                      v-for="(inventorie, index) in recipe.inventories"
                      :key="index"
                    >
                      <span class="k-badge-icon mr-1">
                        <img class="k-recipe__inventory-icon" :src="inventorie.cover_url" alt="inventorie">
                      </span>
                      {{ inventorie.title }}
                    </span>
                  </div>
                </div>
                <div class="d-flex mt-3" v-if="recipe.difficulty">
                  <p class="m-0 mr-2 text-nowrap">Уровень сложности</p>
                  <div class="px-2 d-flex flex-wrap align-items-center justify-content-end w-100">
                    <span class="k-badge badge mx-1" :class="getDiffucltyBadgeClass(recipe.difficulty)">{{ getDifficultyReferences[recipe.difficulty] }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Рецепт -->
      <div class="col-xl-8 k-recipe__step-card" :class="{ 'p-0': $mq === 'xs' || $mq === 'sm' }">
        <div class="k-recipe__card k-recipe__card--fluid-height k-recipe__steps">
          <div class="d-flex justify-content-center mb-3">
            <switcher :items="stepTypeSwitch" :activeItem.sync="recipeTab"/>
          </div>
          <div class="d-flex flex-column" v-if="recipeTab === 'cooking'">
            <div class="k-recipe__steps-step" v-for="(step, index) in recipe.cooking_steps" :key="index">
              <p class="k-recipe__steps-title">Шаг {{ step.position }}</p>
              <div class="k-recipe__steps-row">
                <div class="k-image__overblock">
                  <img class="k-recipe__image k-recipe__steps-image col-xs-12 col-md-3 col-lg-3 p-0" :src="step.cooking_step_cover_url" alt="Recipe step">
                </div>
                <p class="k-recipe__steps-text col-xs-12 col-lg-8">
                  <span v-html="(step.guide || '').replace(/(?:\r\n|\r|\n)/g, '<br>')"></span>
                  <span class="k-recipe__steps-link" v-if="step.hint">
                    <span v-html="parseLinks(step.hint)"></span>
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div class="d-flex flex-column" v-if="recipeTab === 'serving'">
            <div class="k-recipe__steps-title mb-2">На одну порцию</div>
            <div v-html="(recipe.serving || '').replace(/(?:\r\n|\r|\n)/g, '<br>')"></div>
          </div>
        </div>
      </div>

      <div class="col-xl-4 k-recipe__ingridients-card" :class="{ 'p-0': $mq === 'xs' || $mq === 'sm' }">
        <div class="col-12 k-recipe__card k-recipe__card--default k-recipe__card--fluid-height px-0 px-md-3" v-if="recipe.cooking_for && getCookingForMoreInfo.length">
          <div class="k-recipe__card-title k-recipe__card-title--additional">
            <span>Для кого готовим<span v-if="recipe.portion_preview"> · расчёт</span></span>
            <adaptive-propper v-if="!recipe.plan_read_only || recipe.portion_preview" height="80" autobox noscrollbar title="Добавить гостя в списке покупок">
              <template #element>
                <div class="cursor-pointer" style="line-height: 0">
                  <span style="font-size: 9px; margin-right: 5px;">Добавить порцию</span>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="7.11133" width="1.77778" height="16" rx="0.888889" fill="#646465"/>
                    <rect x="16" y="7.11133" width="1.77778" height="16" rx="0.888889" transform="rotate(90 16 7.11133)" fill="#646465"/>
                  </svg>
                </div>
              </template>
              <template #content>
                <div class="d-flex justify-content-center w-100 mb-3">
                  <span
                    class="circle-button circle-button--red mr-3"
                    @click="changeGuestCount(-1)"
                  >
                    <svg
                      width="16"
                      height="2"
                      viewBox="0 0 16 2"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        x="16"
                        y="0.109375"
                        width="1.77778"
                        height="16"
                        rx="0.888889"
                        transform="rotate(90 16 0.109375)"
                        fill="white"
                      />
                    </svg>
                  </span>
                  <span>
                    <!-- <input class="k-invisible-input" :value="getGuestCount" type="number" min="0" max="99" @input="onGuestInput"/> -->
                    {{ getGuestCount }}
                    {{ declOfNum(getGuestCount, ['гость','гостя','гостей']) }}</span>
                  <span
                    class="circle-button circle-button--green ml-3"
                    @click="changeGuestCount(1)"
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect x="7.11108" width="1.77778" height="16" rx="0.888889" fill="white" />
                      <rect
                        x="16"
                        y="7.10938"
                        width="1.77778"
                        height="16"
                        rx="0.888889"
                        transform="rotate(90 16 7.10938)"
                        fill="white"
                      />
                    </svg>
                  </span>
                </div>
              </template>
            </adaptive-propper>
          </div>
          <p v-if="recipe.portion_preview" class="px-3">Предварительный расчёт. В покупки попадёт после выбора даты.</p>
          <p v-if="mutationError" role="alert" class="error-message">{{ mutationError }}</p>
          <div class="k-recipe__persons">
            <div class="k-recipe__persons-row" v-for="person in getCookingForMoreInfo" :key="person.id">
              <img v-if="person.avatar_url" class="k-family__member-avatar" :src="person.avatar_url" alt="avatar">
              <div v-else class="k-family__member-avatar k-family__member-no-avatar">{{ person.name[0] }}</div>
              <div class="k-recipe__persons-name">
                {{ person.name }}
              </div>
              <div class="k-recipe__check-badge k-badge-orange-light" v-if="person.cooking_for.cooking_for === 'f'" @click="cookingFor(person, true)" :aria-disabled="recipe.plan_read_only && !recipe.portion_preview ? 'true' : 'false'">
                <span>
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6 0C6.41421 0 6.75 0.335786 6.75 0.75V5.25H11.25C11.6642 5.25 12 5.58579 12 6C12 6.41421 11.6642 6.75 11.25 6.75H6.75V11.25C6.75 11.6642 6.41421 12 6 12C5.58579 12 5.25 11.6642 5.25 11.25V6.75H0.75C0.335786 6.75 0 6.41421 0 6C0 5.58579 0.335786 5.25 0.75 5.25H5.25V0.75C5.25 0.335786 5.58579 0 6 0Z" fill="#F68C1E"/>
                  </svg>
                </span>
                <span>
                  Добавить
                </span>
              </div>
              <div class="k-recipe__check-badge k-badge-green-light" v-else @click="cookingFor(person, false)" :aria-disabled="recipe.plan_read_only && !recipe.portion_preview ? 'true' : 'false'">
                <span>
                  <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 7.93846L5.11429 12L13 1" stroke="#9DC43B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </span>
                <span>
                  Будет есть
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="k-recipe__warning k-recipe__warning--orange col-12 k-recipe__card k-recipe__card--default k-recipe__card--fluid-height">
          <div class="k-recipe__warning-text">
            <h2>Внимание!</h2>
            <p>Указан вес очищенных и подготовленных продуктов</p>
          </div>
        </div>

        <div v-if="is_special && !recipe.portion_preview && (!recipe.cooking_for || !recipe.cooking_for.length)" class="k-recipe__warning k-recipe__warning--green col-12 k-recipe__card k-recipe__card--default k-recipe__card--fluid-height">
          <div class="k-recipe__warning-text">
            <p>ЧТОБЫ ИЗМЕНИТЬ КОЛИЧЕСТВО ПОРЦИЙ, вернитесь назад в меню и добавьте рецепт в список покупок (нажмите на корзинку)</p>
          </div>
        </div>

        <div v-else-if="!is_special && recipe.plan_context && recipe.plan_context.menu_id && recipe.selected_profile_count === 0" class="k-recipe__warning k-recipe__warning--green col-12 k-recipe__card k-recipe__card--default k-recipe__card--fluid-height">
          <div class="k-recipe__warning-text">
            <p>Чтобы изменить количество порций, добавьте в меню хотя бы один профиль</p>
          </div>
        </div>

        <div class="col-12 k-recipe__card k-recipe__card--default k-recipe__card--fluid-height px-0 px-md-3">
          <div class="k-recipe__card-title k-recipe__card-title--additional">
            <span>Ингредиенты</span>
            <span class="k-recipe__short-desc justify-content-center">{{ recipe.total_weight }} г</span>
            <span class="k-recipe__short-desc text-right justify-content-end">
              {{ recipe.number_of_servings }}
              {{ declOfNum(recipe.number_of_servings, ['порция','порции','порций']) }}
            </span>
          </div>
          <div>
            <div class="d-flex align-items-center mb-2" v-for="(ingredient, index) in getSortedByWeight(recipe.ingredients)" :key="index">
              <span class="mr-4 k-recipe__ingridient-icon">
                <img :src="ingredient.cover_url" alt="">
              </span>
              <div class="k-recipe__ingridient-name">{{ ingredient.title }}</div>
              <div class="text-nowrap">{{ ingredient.amount_title }}</div>
            </div>
          </div>
        </div>
        <div class="k-recipe-read-more col-xl-4 mt-3 mb-5 p-0">
          <div class="k-recipe__card k-recipe__card--default col-12 p-0 p-md-3">
            <div class="k-recipe__card-title">Описание</div>
            <p class="addReadMore showlesscontent" v-html="parseLinks(recipe.recipe_proportion.description).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { readFailure } from '../utils/legacy-safety';
  import GoBack from '../components/TheGoBack';
  import AdaptivePropper from '../components/TheAdaptivePropper.vue';

  import Switcher from '../components/TheSwitcher.vue';
  import { getRecipe, setCookingFor, getRecipePreview, isRecipeAccessDenied, canRetryRecipeRead } from '../api/RecipeApi';
  import KSpinner from '../components/TheSpinner.vue';
  import { declOfNum } from '../utils/helper';
  import { mapGetters } from 'vuex';
  import cloneDeep from 'lodash/cloneDeep';

  // import KCalendar from "../components/TheCalendar";
  import dateFormat from "@/utils/dateformat";

  export default {
    name: 'ReceipesDetail',
    filters: {
      twoAfterDot: (value) => value.toFixed(2)
    },
    components: { GoBack, AdaptivePropper, Switcher, KSpinner },

    data: () => ({
      recipe: null,
      readError: false,
      readErrorRetryable: false,
      lockedRecipe: null,
      recipeLoading: false,
      recipeTab: 'cooking',
      stepTypeSwitch: [{ tab: 'cooking', title: 'Приготовление'}, { tab: 'serving', title: 'Сервировка' }],
      declOfNum,
      id: null,
      date: null,
      meal_id: null,
      set_meal_id: null,
      is_special: false,
      profile_tip: false,
      previewGuests: 0,
      previewExcluded: [],
      requestIsSending: false,
      mutationError: "",
    }),
    beforeDestroy() { this._recipeReadVersion = (this._recipeReadVersion || 0) + 1; },
    watch: {
      readContext: { immediate: true, handler() { this.previewGuests = 0; this.previewExcluded = []; this.mutationError = ""; this.loadRecipe(); } },
    },
    computed: {
      readContext() {
        const q = this.$route.query;
        const rights = [
          this.getUserSets.map(right => [right.id, right.recipe_set_id, right.is_paid, right.profile_recipe_sets]),
          this.getUserSubscribes.map(right => [right.id, right.menu_id, right.is_paid, right.started_at, right.finished_at, right.meal_types, right.profile_subscription_meals]),
        ];
        return JSON.stringify([this.getCurrentProfile.id, this.getUserFamily.map(p => [p.id, p.portion_size]), rights, this.$route.name, this.$route.params.id, q.recipe_id, q.date, q.menu, q.type, q.meal_id, q.set_meal_id, q.subscription_id, q.user_recipe_set_id]);
      },
      ...mapGetters([
        'getDifficultyReferences',
        'getUserFamily',
        'getCurrentProfile',
        'getUserSubscribes',
        'getUserSets',
      ]),
      isNotFullProfile() {
        return !this.getCurrentProfile.calories;
      },
      getGuestCount() {
        const guestObject = this.recipe.cooking_for.find(el => !el.profile_id);
        return guestObject ? guestObject.guest_count : 0
      },
      getCookingForMoreInfo() {
        if (!this.recipe.cooking_for) return [];

        const family = cloneDeep(this.getUserFamily);
        for (const profile of (this.recipe.historical_profiles || [])) {
          if (!family.some(member => member.id === profile.id)) family.push(profile);
        }

        for (const member of family) {
          const current = this.recipe.cooking_for.find(el => el.profile_id === member.id);
          if (!current) continue;

          this.$set(member, 'cooking_for', current);
        }

        return family.filter(el => !!el.cooking_for);
      },
      getGoBackText() {
        if (this.$route.query.is_purchase) {
          return 'Назад к покупкам';
        }
        return 'Назад к меню';
      }
    },
    created() {
      if (!this.$route.query.recipe_id) this.$emit('close');
    },
    methods: {
      parseLinks(text) {
        if (!text) return '';
        return this.linkify(text);
      },
      linkify(inputText) {
          var replacedText, replacePattern1, replacePattern2, replacePattern3;

          //URLs starting with http://, https://, or ftp://
          // eslint-disable-next-line no-useless-escape
          replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
          replacedText = inputText.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');

          //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
          // eslint-disable-next-line no-useless-escape
          replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
          replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');

          //Change email addresses to mailto:: links.
          // eslint-disable-next-line no-useless-escape
          replacePattern3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
          replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>');

          return replacedText;
      },
      getSortedByWeight(ingregients) {
        return [...ingregients].sort((a, b) => b.amount_value - a.amount_value)
      },
      onGuestInput({ target }) {
        if (parseInt(target.value, 10) > 99) {
          target.value = this.getGuestCount;
        }
      },
      getAdditionalData() {
        if (this.recipe?.plan_context) return { ...this.recipe.plan_context };
        const additional = {};
        const query = this.$route.query;
        if (this.is_special) {
          additional.recipe_set_id = query.menu || this.$route.params.id;
          if (query.user_recipe_set_id) additional.user_recipe_set_id = query.user_recipe_set_id;
          if (query.set_meal_id) additional.set_meal_id = query.set_meal_id;
        } else {
          additional.menu_id = query.menu || this.$route.params.id;
          if (query.subscription_id) additional.subscription_id = query.subscription_id;
          if (query.meal_id) additional.meal_id = query.meal_id;
        }
        return additional;
      },
      async saveCookingFor(payload) {
        if (this.requestIsSending) return;
        this.requestIsSending = true;
        this.mutationError = "";
        const context = this.readContext;
        try {
          const { data } = await setCookingFor(payload);
          if (!data || !data.success) throw new Error('SaveNotConfirmed');
          if (context === this.readContext) await this.loadRecipe();
        } catch (error) {
          if (context === this.readContext) this.mutationError = "Не удалось подтвердить сохранение. Повторите действие.";
        } finally { this.requestIsSending = false; }
      },
      async changeGuestCount(value) {
        if (this.recipe.plan_read_only) {
          this.previewGuests = Math.max(0, Math.min(99, this.getGuestCount + value));
          await this.loadRecipe(); return;
        }
        if (this.getGuestCount + value < 0) return;

        const existing = this.recipe.cooking_for.find(el => !el.profile_id) || this.recipe.cooking_for[0];
        const current = existing && { ...existing };

        if (!current) return;

        delete current.profile_id


        await this.saveCookingFor({
          ...current,
          guest_count: this.getGuestCount + value,
          cooking_for: 't',
          meal_id: this.meal_id,
          set_meal_id: this.set_meal_id,
        })
      },
      async cookingFor(person, active, guests_count = false) {
        if (this.recipe.plan_read_only) {
          if (!this.recipe.portion_preview) return;
          this.previewExcluded = active ? this.previewExcluded.filter(id => id !== person.id) : [...this.previewExcluded, person.id];
          await this.loadRecipe(); return;
        }
        const copyPerson = {...person.cooking_for};
        if (guests_count) {
          copyPerson.profile_id = '';
          copyPerson.guests_count = guests_count;
        }

        // delete person.cooking_for.set_meal_id; // todo
        // const guestObject = this.recipe.cooking_for.find(el => !el.profile_id);

        const context = { ...person.cooking_for };
        delete context.portion_size;
        await this.saveCookingFor({
          ...context,
          cooking_for: active ? 't' : 'f',
          meal_id: this.meal_id,
          set_meal_id: this.set_meal_id,
          ...this.getAdditionalData(),
        })
      },
      async loadRecipe() {
        const version = this._recipeReadVersion = (this._recipeReadVersion || 0) + 1;
        this.recipe = null;
        this.lockedRecipe = null;
        this.readError = false;
        this.readErrorRetryable = false;
        this.recipeLoading = false;
        if (!this.getCurrentProfile.id || !this.$route.query.recipe_id) return;
        const query = { ...this.$route.query };
        this.id = query.recipe_id;
        this.date = query.date;
        this.meal_id = query.meal_id;
        this.set_meal_id = query.set_meal_id;
        this.is_special = query.type === 'special' || ['ReceipesSpecial', 'ReceipesSpecialPartner'].includes(this.$route.name);
        const previewContext = { id: this.id, menu: query.menu || this.$route.params.id, date: this.date, special: this.is_special };
        this.recipeLoading = true;
        try {
          const response = await getRecipe({ id: this.id, date: this.date, ...this.getAdditionalData(), preview_guests: this.previewGuests, preview_excluded: this.previewExcluded.join(',') });
          if (version !== this._recipeReadVersion) return;
          if (!response.data?.success || !response.data.data?.recipe) {
            const error = new Error('RecipeUnavailable');
            error.response = response;
            throw error;
          }
          this.recipe = response.data.data.recipe;
          this.meal_id = this.recipe.plan_context?.meal_id || null;
          this.set_meal_id = this.recipe.plan_context?.set_meal_id || null;
          if (!this.recipe.difficulty) this.$set(this.recipe, 'difficulty', 'normal');
        } catch (error) {
          if (version !== this._recipeReadVersion) return;
          try {
            if (!isRecipeAccessDenied(error)) throw error;
            const preview = await getRecipePreview(previewContext);
            if (version !== this._recipeReadVersion) return;
            if (preview) this.lockedRecipe = preview;
            else this.readError = 'Рецепт недоступен.';
          } catch (failure) {
            if (version !== this._recipeReadVersion) return;
            this.readError = readFailure(failure, 'Не удалось загрузить рецепт.');
            this.readErrorRetryable = canRetryRecipeRead(failure);
          }
        } finally {
          if (version === this._recipeReadVersion) this.recipeLoading = false;
        }
      },
      getDiffucltyBadgeClass(difficulty) {
        switch(difficulty) {
          case 'easy': return 'k-badge-green-light';
          case 'normal': return 'k-badge-orange';
          case 'hard': return 'k-badge-red-light';

          default: return 'k-badge-orange'
        }
      },

      setDateToRecipe(recipe, date) {
        this.$set(recipe, 'meal_type', null);

        this.$set(recipe, "date", new Date(date));
        const existSetMealWithDate = recipe.set_meals.find(el => dateFormat(el.date, 'yyyy-mm-dd') === dateFormat(date, 'yyyy-mm-dd'))

        if (existSetMealWithDate) {
          recipe.meal_type = existSetMealWithDate.meal_type || ''
          this.$forceUpdate();
        }
      },

      getFillColorByMeal(recipe) {
        if (recipe.will_not_cook === 'f') {
          return '#D51E3A';
        }
        if (recipe.will_not_cook === 't') {
          return '#9DC43B';
        }
        return  '#A3A3A3';
      }
    }
  }
</script>

<style lang="scss" scoped>
.custom-content {
  background: #fff;
  height: 100vh;
  overflow: scroll;
}
input[type='number'] {
  -moz-appearance:textfield;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.k-invisible-input {
  border: unset;
  outline: unset;
  text-align: center;
  border-bottom: 1px solid #808080;
}
.k-recipe__inventory-icon {
  max-width: 18px;
  mix-blend-mode: multiply;
}

.k-recipe__tip-absolute {
  position: absolute;
  top: -35px;
  right: 15px;
}

.k-recipe__tooltip {
  background: #F68C1E;
  border-radius: 0px 0px 4px 4px;
  color: #fff;
  max-height: 0px;
  transition: max-height .5s linear;
  overflow: hidden;
  font-size: 12px;
  letter-spacing: -0.5px;
  color: #FFFFFF;

  &.active {
    max-height: 500px;
  }
}

.btn-to-top {
  background: #FFFFFF;
  box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.1);
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  right: 25px;
  bottom: 25px;
  z-index: 20;
}

@supports (-ms-ime-align:auto) {
  .k-badge-gray {
    background: transparent;
    background-color: transparent;
  }
}
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none){
  .k-badge-gray {
    background: transparent;
    background-color: transparent;
  }
}
@media screen and (max-width: 767px) {
  .k-filter__switcher  {
    height: 40px;
  }
  .k-filter__switcher-item {
    padding: 0 10px !important;
  }
  .k-recipe__steps-row > .k-image__overblock {
    margin-bottom: 10px;
  }
}
</style>
